import React from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] pt-40 flex flex-col items-center justify-center text-center px-6">
      <Seo title="Page Not Found" />
      <p className="ee-overline mb-4">404</p>
      <h1 className="font-display text-5xl md:text-7xl tracking-tight">This page has wandered off.</h1>
      <Link to="/" className="mt-10 bg-[#D4AF37] text-[#0C0A09] px-10 py-4 uppercase tracking-[0.15em] text-sm hover:bg-[#B5952F] transition-colors">
        Return Home
      </Link>
    </div>
  );
}
